import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { BreadcrumbComponent } from '../Partials/Breadcrumb';
import { requestGet } from '../../api/request';
import { MAIN_URL, STRUCTURES_BY_ID } from '../../api/url';
import * as actions from '../../redux/actions';

const GovernmentById = () => {
  const { govId } = useParams();
  const dispatch = useDispatch();
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);
  const [data, setData] = useState([]);

  const getData = async () => {
    const response = await requestGet(STRUCTURES_BY_ID, {
      'id': govId,
      'lang_id': currentLanguage.id,
    });

    if (response.success) {
      setData(response.data);
    }
  };

  const newStyle = () => {
    const select = document.querySelectorAll('.decree-item__text *');
    for (let i = 0; i < select.length; i += 1) {
      const elem = select[i];
      elem.style.fontFamily = 'PT Sans Narrow Regular';
    }
  };

  useEffect(() => {
    if (data) {
      dispatch(actions.adjustFontSize(fontSize));
      newStyle();
    }
  });

  useEffect(() => {
    getData();
  }, [dictionary]);

  return (
    <section className="section">
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            <div className="breadcrumbs mt-4">
              <div className="breadcrumbs-container">
                <BreadcrumbComponent />
              </div>
            </div>
            {data ? (
              <div className="decree-item">
                <div className="decree-item__container">
                  {data.assets ? (
                    <div className="decree-item__img">
                      <img
                        src={`${MAIN_URL}events/original/${data.assets[0].src}`}
                        alt=""
                      />
                    </div>
                  ) : null}

                  <div className="decree-item__content">
                    <div className="decree-item__name">
                      <b>
                        <span>{data.name}</span>
                        <br />
                        <span>{data.description}</span>
                      </b>
                      <br />
                    </div>
                    <div className="decree-item__text">
                      <div dangerouslySetInnerHTML={{ __html: data.text }} />
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GovernmentById;
